import moment from 'moment';

function FormatDateFilter() {
    return function(value, format) {
        if (!value) {
            return '';
        }
        format || (format = 'DD/MM/YYYY');
        return moment(value).format(format);
    };
}

export default FormatDateFilter;
